import { render, staticRenderFns } from "./RiskTypeList.vue?vue&type=template&id=0b66e540&scoped=true&"
import script from "./RiskTypeList.vue?vue&type=script&lang=js&"
export * from "./RiskTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b66e540",
  null
  
)

export default component.exports